.configsContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-content: flex-start;
  row-gap: 12px;
  column-gap: 24px;
  overflow: auto;
}

.featureContainer {
  row-gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  transition:
    background-color 0.3s ease-in-out,
    color 0.3s ease-in-out;

  &.inlineConfigContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &.highlighted {
    @include themify($themes) {
      background-color: themed("neutral-tertiary");
    }
  }

  .helpText {
    transition: color 0.3s ease-in-out;
  }
}

.configInfoContainer {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.importButton {
  margin-right: auto;
  margin-left: 20px;
}

.switchWrapper {
  height: 100%;
  display: flex;
  align-items: flex-start;
}

.inputContainer {
  max-width: 300px;
  padding-top: 12px;
}

.header {
  position: sticky;
  top: 0;
}

.footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px;
  @include themify($themes) {
    border-top: 1px solid themed("neutral-secondary");
  }
}

.pageWrapper {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: calc(100% - 70px) 70px;
}

.headerAndItemsContainer {
  display: flex;
  flex-direction: column;
  transition: opacity 0.25s ease-out;
  opacity: 1;
  height: 100%;

  &.pageSubmitting {
    transition: opacity 0.25s ease-in;
    opacity: 0.75;
    user-select: none;
    cursor: wait;

    .configsContainer {
      pointer-events: none;
    }
  }
}

.helpText {
  font-size: 14px;
  max-width: 90%;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.configsSearchNoResults {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  row-gap: 12px;
  text-align: center;
  font-size: 14px;
  @include themify($themes) {
    color: themed("neutral-primary");
  }
}

.objectRowContainer {
  max-height: 40px;
}

.importConfigModal {
  width: 450px;

  .searchContainer {
    border-radius: 12px;
    display: flex;
    align-items: center;
    position: relative;
    margin: 20px 0;
    > svg {
      position: absolute;
      cursor: auto;
      left: 12px;
      top: 50%;
      transform: translate(0, -50%);
      z-index: 9999999;
    }
    @include themify($themes) {
      border: solid 1px themed("neutral-secondary");
    }
  }

  .selectControl {
    padding-left: 36px;
  }
}

.headerButtonsContainer {
  display: flex;
  column-gap: 12px;
  align-items: center;
  margin-right: 12px;
}

.modalSelectContainer {
  margin-top: 24px;
}

.configValueContainer {
  position: relative;
}

.notEditableConfig {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  cursor: not-allowed;
  @include themify($themes) {
    background-color: rgba(themed("background"), 0.5);
  }
}
